import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';
import type { GetDataLibraryItemApiResponse } from '../models/get-data-library-item';

@Injectable({ providedIn: 'root' })
export class DataLibraryItemApiService {
  private readonly http = inject(HttpClient);
  private readonly cache = new Map<
    string,
    Observable<GetDataLibraryItemApiResponse>
  >();

  getItem(itemId: string): Observable<GetDataLibraryItemApiResponse> {
    const key = itemId.trim();
    const existing = this.cache.get(key);
    if (existing) {
      return existing;
    }

    const request$ = this.http
      .get<GetDataLibraryItemApiResponse>(
        `${environment.baseUrl}/data-library/items/${encodeURIComponent(key)}`,
      )
      .pipe(
        catchError((error) => {
          this.cache.delete(key);
          return throwError(() => error);
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );

    this.cache.set(key, request$);
    return request$;
  }
}
